import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseXlsxCsvPreviewService } from '../../services/base-xlsx-csv-preview.service';
import { BaseXlsxCsvPreview } from '../../interfaces/base-xlsx-csv-preview.interface';

@Component({
  selector: 'base-xlsx-csv-preview',
  templateUrl: './base-xlsx-csv-preview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaseXlsxCsvPreviewComponent implements OnInit {
  /** Set by BaseXlsxCsvPreviewService.open() on the component instance. */
  file: File;

  preview?: BaseXlsxCsvPreview;
  isEmpty = true;

  constructor(
    private readonly activeModal: NgbActiveModal,
    private readonly previewService: BaseXlsxCsvPreviewService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.previewService
      .parse(this.file)
      .then((preview) => {
        this.preview = preview;
        this.isEmpty = !preview.headers.length && !preview.rows.length;
      })
      .catch(() => {
        this.isEmpty = true;
      })
      .finally(() => this.cdr.markForCheck());
  }

  close(): void {
    this.activeModal.dismiss();
  }
}
